require("dotenv").config();

export const apiUrl = process.env.REACT_APP_API_URL;
export const clientIdGG = process.env.REACT_APP_CLIENTIDGG;

export const uploadFileUrl = `${apiUrl}api/v1/notifications/upload-file?`;
